/*
  carousel.js — Edible Growth Shopify Theme
  Port of InfoCarousel.jsx's useAnimationFrame auto-scroll logic to
  native requestAnimationFrame. Identical scroll behaviour, no Framer dep.

  Expects an element with data-carousel="auto-scroll" wrapping the strip.
  Pause on hover mirrors the original React onMouseEnter/Leave behaviour.
*/

(function () {
  'use strict';

  var SCROLL_SPEED = 0.5; /* px per frame — matches InfoCarousel */

  function initCarousel(stripEl) {
    var isPaused = false;

    /* Duplicate children for seamless infinite scroll
       (InfoCarousel duplicates cardItems into duplicatedItems) */
    var children   = Array.from(stripEl.children);
    var origCount  = children.length;

    /* Only clone if originals haven't already been duplicated */
    if (!stripEl.dataset.cloned) {
      children.forEach(function (child) {
        stripEl.appendChild(child.cloneNode(true));
      });
      stripEl.dataset.cloned = 'true';
    }

    /* Pause / resume on hover */
    var section = stripEl.closest('[data-carousel-section]') || stripEl.parentElement;
    if (section) {
      section.addEventListener('mouseenter', function () { isPaused = true; });
      section.addEventListener('mouseleave', function () { isPaused = false; });
    }

    /* Manual prev/next buttons */
    var prevBtn = section && section.querySelector('[data-carousel-prev]');
    var nextBtn = section && section.querySelector('[data-carousel-next]');

    function getCardWidth() {
      /* Same formula as InfoCarousel.scroll() */
      return stripEl.scrollWidth / (origCount * 2);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        stripEl.scrollBy({ left: -getCardWidth() * 4, behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        stripEl.scrollBy({ left: getCardWidth() * 4, behavior: 'smooth' });
      });
    }

    /* Auto-scroll RAF loop */
    function tick() {
      if (!isPaused) {
        var half = stripEl.scrollWidth / 2;
        stripEl.scrollLeft = (stripEl.scrollLeft + SCROLL_SPEED) % half;
      }
      requestAnimationFrame(tick);
    }

    requestAnimationFrame(tick);
  }

  function init() {
    document.querySelectorAll('[data-carousel="auto-scroll"]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
